import { IFormField } from '../../../../../../infra/formBuilder/field/formField.interface';
import { FormBuilderEnums } from '../../../../../../infra/formBuilder/formBuilder.service';
import { DateUtils } from '../../../../../../nddUtils/dateUtils.service';
import { getAlphabeticalSortPickupInstLib } from '../../../../../../appConfig/appConfigForward';
import { MappingTablesCache } from '../../../../../../mappingTablesCache/mappingTablesCache.service';
import { getInjectableName } from 'ng-metadata/core';
import { ConfigurationUtil } from '../../../../../../nddUtils/configurationUtil.service';

const uniqBy = require('lodash/uniqBy');
const flatten = require('lodash/flatten');
const filter = require('lodash/filter');
const forEach = require('lodash/forEach');
const includes = require('lodash/includes');
const split = require('lodash/split');
const getValue = require('lodash/get');
var angular: angular.IAngularStatic = require('angular');

let initInjector: ng.auto.IInjectorService = angular.injector(['ng']);
let $timeout = initInjector.get<ng.ITimeoutService>('$timeout');

export class AbstractRequest {
    protected formFields: IFormField[];

    protected sectionsMap;

    constructor(
        private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
    ) {

    }
   
    protected getFields() {
        return this.formFields;
    }

    protected getSectionsMap() {
        return this.sectionsMap;
    }

    protected itemsArrayPopulator(field, form, formData, data): void {

        /* update data by field's path */
        let dataAndKey = this.getIlsDataByPath(data, field, formData);
        let key = dataAndKey.key;

        data = dataAndKey.data;

        if (!key) { //no key found, update it as field's name
            key = field.name;
        }

        if (!data) {
            field.options = []; //no data, no options
            return;
        }

        if (field.duplicateOf) {
            if (this.isDuplicatedFieldExists(form, field)) {
                //field.options = [];
                return;
            }
        }

        // filter data by another fields
        let filteredData = this.filterPopulator(form, field, formData, data);

        if (!angular.isArray(filteredData)) {
            filteredData = [filteredData];
        }

        let array = filteredData.map((item, index, array2) => this.parseDataForMultiSelect(item, field, formData));
        array = flatten(array);
        let needSorting = getAlphabeticalSortPickupInstLib() && this.configurationUtil.isSuprima() &&(field.key === 'pickupLocation' || field.key === 'owner');
        if (needSorting)
        {
            /*
            Sorting pickup location in Primo VE as get it as follows:
            1. If there are campuses they should be sorted alphabetically, and inside each campus the libraries should be sorted also alphabetically.
            2. If there are only libraries - they should be sorted alphabetically.
            3. In case the user is associated with a specific campus, his campus should appear first in the list, and all other locations should be sorted alphabetically right after it.
            4. Personal delivery should be last
            See Jira URM-113426 and URM-207402
             */
                let sortedPickupLocationList = array.sort((a, b) => {
                // Sort by user affiliated campus (true comes first)
                const isAffiliatedA = a.userAffiliatedCampus ? 1 : 0;
                const isAffiliatedB = b.userAffiliatedCampus ? 1 : 0;
                
                // If the flags are different, return the result of flagSort
                if (isAffiliatedA !== isAffiliatedB) {
                    // `true` (1) should come before `false` (0)
                    return isAffiliatedB - isAffiliatedA; 
                }

                // Special case: If category is "Personal delivery," place it at the end
                 if (a.category && a.category.toLowerCase() === 'personal delivery') {
                    return 1;
                } else if (b.category && b.category.toLowerCase() === 'personal delivery') {
                    return -1;
                }
                if(a.category !== undefined){
                    // Sort alphabetically by categories
                    const categorySort = a.category.localeCompare(b.category);

                    // If the categories are different, return the result of categorySort
                    if (categorySort != 0) {
                        return categorySort;
                    }
                 }

                // Sort alphabetically by labels (location value)
                return a.label.localeCompare(b.label);
            });

            field.options = uniqBy(sortedPickupLocationList, 'label').filter(this.filterEmpty);
        }
    else {
            field.options = uniqBy(array, 'label').filter(this.filterEmpty);
        }

    }

    protected freeTextPopulator(field, form, formData, data): void {
        this.updateDefaultValue(field, data, formData);

        field.options = { dummy: 'dummy' };

        if (formData[field.name]) {
            field.disabled = true;
        }
    }

    protected hardCodedPopulator(field, form, formData, data) {
        /* pass on field JSON a temporary field to disable to multi value check */
        field.disableMultiValueCheck = true;
        if (!this.isIlsFieldExists(data, formData, field)) { //reset options
            field.options = {};
        }
    }

    protected parseDataForMultiSelect(item, field, formData) {

        if (!item) {
            return [];
        }

        let key = this.getRequestKey(field, formData);
        let value = item[key];

        /*  value is array - recursive
         *  For each node in the array, run parseDataForMultiSelect again
         */
        if (angular.isArray(value)) {
            let results = value.map((item1, index, array1) =>
                this.parseDataForMultiSelect(item1, field, formData)).filter(this.filterEmpty);
            return results;
        }

        /* get params from field configuration, if exist */
        let params;
        if (field.populator) {
            params = field.populator.params;
        }

        // value is Json? - build options from it
        if (angular.isObject(value)) {
            /* Field is in Json format, key and value declared in it
               name is pickup_location
                "pickup_location": {
                            "pickup_location_name": "GWCC Circulation Desk",
                            "pickup_location_code": "19"
                 },

            */



            if (params && params.key && params.value) {
                if (!formData[field.name] && value.default === 'Y') {
                    this.updateFormData(formData, field, value[params.key]);
                    //formData[field.name] =  keyValue.key;
                }
                return { label: value[params.value], value: value[params.key] };
            }
            let options = [];

            forEach(value, function (curValue, curKey) {
                options.push({ label: curKey, value: curValue });
            });

            return options;
        }

        /* Field is in Json format which 'byKey' represent the current key and byValue the values
         * e.g.
          {
                "field-name":"item_category",
                "field-values":[
                    {
                        "value":"Book",
                        "key":"Book"
                    }
                ],
                "mandatory":false
            }
         */
        if (params && params.byKey && item[params.byKey] === key && params.byValue && item[params.byValue]) {
            let options = [];
            if (!params.byCategory) {
                forEach(item[params.byValue], (keyValue) => {
                    if (params.key && params.value) {
                        options.push({
                            label: keyValue[params.value],
                            value: keyValue[params.key]
                        });
                    } else {
                        options.push({
                            label: keyValue.value,
                            value: keyValue.key
                        });

                        if (!formData[field.name] && (keyValue.default === 'Y' || keyValue.default === 'Yes')) {
                            this.updateFormData(formData, field, keyValue.key);
                            //formData[field.name] =  keyValue.key;
                        }
                    }
                });
                return options;
            } else {
                let categories = [];
                forEach(item[params.byValue], (category) => {
                    let options = [];
                    forEach(category.optionsList, (keyValue) => {
                        options.push({
                            label: keyValue.value,
                            value: keyValue.key
                        });
                    });
                    categories.push({
                        label: category[params.byCategory],
                        options: options
                    });
                });
                return categories;
            }
        }

        if (params && params.byCategory && params.value && params.key) {
            if(field.name=="pickupLocation"){
                return { label: item[params.value], value: item[params.key], category: item[params.byCategory], userAffiliatedCampus: item.userAffiliatedCampus};
            }
            return { label: item[params.value], value: item[params.key], category: item[params.byCategory] };

        }

        // in recursive - get value from declare key and value (from params)
        if (params && params.key) {
            if (!formData[field.name] && item['default'] === 'Y') {
                this.updateFormData(formData, field, item[params.key]);
                //formData[field.name] =  item[params.key];
            }
            return { label: item[params.value], value: item[params.key] };
        }

        // get value from ils data
        if (angular.isObject(item)) {

            return { label: item[key], value: item[key] };
        }

        return { label: item, value: item };
    }

    protected datePopulator(field, form, formData, data): void {
        if (!field.populator || !field.populator.params || !field.populator.params.path) {
            return;
        }

        if (!data) {
            field.options = []; //no data, no options
            return;
        }

        if (angular.isArray(data)) {
            data = data[0]; //TODO
        }

        let options = [];
        forEach(data[field.populator.params.path], (option) => {
            options.push({
                day: option[0],
                month: option[1],
                year: option[2]
            });
        });

        field.options = options;

    }

    protected timeSlotPopulator(field, form, formData, data): void {
        /* update data by field's path */
        let dataAndKey = this.getIlsDataByPath(data, field, formData);
        let key = dataAndKey.key;

        data = dataAndKey.data;

        if (!key) { //no key found, update it as field's name
            key = field.name;
        }

        if (!data) {
            field.options = []; //no data, no options
            return;
        }

        if (!field.dependOn || !field.dependOn.key) { //|| !angular.isArray(field.dependOn)
            field.options = [];
            return;
        }

        let dateUtils: DateUtils = new DateUtils();
        let filterBy;
        if (!angular.isArray(field.dependOn)) {
            filterBy = formData[field.dependOn.key];
            if (filterBy instanceof Date) {
                filterBy = dateUtils.convertDateTypeToIlsDateString(filterBy);
            }
        }

        if (angular.isArray(data)) {
            data = data[0]; //TODO
        }

        data = data[key];

        if (!filterBy) {
            field.options = [];
            return;
        }

        data = data[filterBy];

        let array = data.map((item, index, array2) => this.parseTimeForMultiSelect(item, field, formData));

        field.options = array;

    }

    protected filterEmpty(e) {
        return e.value || e.options;
    }

    protected onChange(): string {
        return '';
    }

    protected onClick(): string {
        return '';
    }

    protected handleField(field, form, formData, data, params) { //field,form,formData,data
        /* if uiType is multiple labels, fill the data with 'dummy'
         * This is for fixing the dependOn field where it checks the formData which is always undefined
         */
        if (field.uiType === FormBuilderEnums.UI_TYPE.MULTI_LABEL && field.options && field.options.length > 0) {
            this.updateFormData(formData, field, 'DUMMY');
            //formData[field.name] = 'DUMMY';
        }

        /* update default value by form definition */
        if (field.populator && field.populator.params && (field.populator.params.defaultValue || field.populator.params.defaultValuePath)) {

            /* check if drop-down populate was changed (by trigger) */
            if (field.populator.params.filters && includes(field.populator.params.filters, params.trigger)) {
                //reset form data
                delete formData[field.name];
            }


            //formData[field.name] = field.populator.params.defaultValue; TODO ???
            if (!formData[field.name] && // No option selected yet
                field.options && field.options.length > 0 && // There is at least one option exists
                field.populator.params.defaultValue === FormBuilderEnums.FIRST) { // First option as default
                this.updateFormData(formData, field, field.options[0].value);
            }

            if (!formData[field.name] && // No option selected yet
                field.options && field.options.length > 0 && // There is at least one option exists
                field.populator.params.defaultValuePath) { // First option as default
                let curValue = angular.isArray(data) ?
                     data[0][field.populator.params.defaultValuePath] : data[field.populator.params.defaultValuePath];
                if(curValue &&
                  field.populator.params.defaultValue === FormBuilderEnums.FIRST_ONLY_IF_DEFAULT_VALUE_PATH_EXIST){
	                 this.updateFormData(formData, field, field.options[0].value);
                  }else{
                     this.updateFormData(formData, field, curValue);
                  }
                //if (angular.isArray(data)) {

                //formData[field.name] = data[0][field.populator.params.defaultValuePath];
                //}else{
                //   this.updateFormData(formData, field, data[field.populator.params.defaultValuePath]);
                //formData[field.name] = data[field.populator.params.defaultValuePath];
                //}
               
            }
        }

        /* relationships between fields */
        if (field.dependOn) {

            if (field.dependOn.method) {
                field.dependOn.method(field, this.formFields, formData, data);
            }

            /* depend on existing ILS fields (i.e. selection radio button field */
            if (field.dependOn.ilsFields) {
                let showMe: boolean = true;
                forEach(Object.keys(field.dependOn.ilsFields), (group) => {
                    let ilsFieldExists: boolean = false;
                    forEach(field.dependOn.ilsFields[group], (curIlsFieldName) => {
                        let ilsField = this.getFieldByName(form, curIlsFieldName);
                        if (!ilsFieldExists) {
                            ilsFieldExists = this.isIlsFieldExists(data, formData, ilsField);
                        }
                    });
                    showMe = showMe && ilsFieldExists;
                });

                if (!showMe) {
                    field.uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
                    delete formData[field.name]; //reset selection
                }

                return;

            }

            if (!field.uiTypeBack) { // keep uiType
                field.uiTypeBack = field.uiType;
            }
            if (!field.fieldTypeBack) { // keep fieldType
                field.fieldTypeBack = field.fieldType;
            }
            if (!field.mandatoryBack) { // keep mandatory
                field.mandatoryBack = field.mandatory;
            }

            //show it if dependOn field exists (with data)
            /* true if:
             * field.dependOn.isExists is true and formData[field.dependOn.key] exists (true)
             * field.dependOn.isExists is false and formData[field.dependOn.key] is undefined (false)
             * that means - field.dependOn.isExists == formData[field.dependOn.key]
             */
            if (!field.dependOn.method) {
                let hide = false;
                if (!angular.isArray(field.dependOn)) {
                    field.dependOn = [field.dependOn];
                }


                forEach(field.dependOn, (condition) => {
                    let conditionField = this.getFieldByName(form, condition.key);
                    if (condition.behavior === FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED){
                        field.disabled =true;
                        field.mandatory=false;
                    }
                    if (condition.showIfFieldByKeyDoesntExist && condition.showIfFieldByKeyDoesntExist === 'false' && !formData[condition.key]) {
                        hide = true;
                    }
                    else if (condition.isExists === !!formData[condition.key] || condition.booleanCheckVar) {
                        field.uiType = field.uiTypeBack;
                        field.fieldType = field.fieldTypeBack;
                        field.mandatory = field.mandatoryBack;
                        field.disabled = false;

                        //show it if dependOn field value is as in field.dependOn.value (the field by key must be exists)
                    } else if (condition.value && ((conditionField.uiType !== FormBuilderEnums.UI_TYPE.CHECK_BOX && !formData[condition.key]) || formData[condition.key] === condition.value)) {
                        field.uiType = field.uiTypeBack;
                        field.fieldType = field.fieldTypeBack;
                        field.disabled = false;
                    } else if (condition.booleanValue && condition.booleanValue === 'false' && !this.checkIfCondValEqFormCondKey(formData, condition)) {
                        field.uiType = field.uiTypeBack;
                        field.fieldType = field.fieldTypeBack;
                        field.disabled = false;
                    } else if ((!condition.booleanValue || condition.booleanValue === 'true') && this.checkIfCondValEqFormCondKey(formData, condition)) {
                        field.uiType = field.uiTypeBack;
                        field.fieldType = field.fieldTypeBack;
                        field.disabled = false;
                    } else if (condition.behavior !== FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED){
                        hide = true;
                    }
                });



                if (hide) {
                    field.fieldType = FormBuilderEnums.FIELD_TYPE.INTERNAL;
                    if (field.dependOn.behavior === FormBuilderEnums.BEHAVIOR.DISABLED) {
                        delete formData[field.name];
                        field.disabled = true;
                    } else {
                        field.uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
                    }
                }

                if (field.dependOn.length === 1) {
                    field.dependOn = field.dependOn[0];
                }

                /* ------- Check boolean variable on the json data in order to hide the field -------- */
                if (field.dependOn.booleanCheckVar) {
                    let existingPath = field.dependOn.booleanCheckVar;
                    let boolValue = this.parseDataAndKeyFromPath(data, existingPath, formData);
                    let key = boolValue.key;
                    let value = boolValue.data;
                    if (!value) {
                        field.uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
                    }
                }

            }
        }
        /* update field as label if it contains options but only one and the form is read on the first time */
        let firstTime = !params.trigger;
        if (field.uiType !== FormBuilderEnums.UI_TYPE.CHECK_BOX && field.options && field.options.length === 1) {

            /* If field is depend on another field and by its value,
             * This field should remains as disabled
             */
            if (field.dependOn && !angular.isDefined(field.dependOn.isExists)) {
                field.disabled = true;
            }

            /* Field could become as label if
             * 1. It is not already disabled
             * 2. The form is loaded on the first time
             * 3. Field is not hidden
             */
            if (!field.disabled) {
                if (firstTime && field.uiType !== FormBuilderEnums.UI_TYPE.HIDDEN) {
                    if (!field.saveFormField) {
                        field.saveFormField = {};
                    }
                    field.saveFormField.uiType = field.uiType;

                    if (this.singleValueBehaviourDefined(field)) {
                        field.uiType = field.populator.params.singleValueBehaviour;
                    } else {
                        field.uiType = FormBuilderEnums.UI_TYPE.LABEL;
                    }
                } else {
                    field.disabled = true;
                }
                field.value = field.options[0].label; //for display
            }
            this.updateFormData(formData, field, field.options[0].value);
            //this.updateFormDataFromFirstOption(formData, field, params); //for submit
        }

        // In case a field was changed to a label, and later got its options back, the original UI type needs to be restored
        if (this.needToRestoreUiType(field)) {
            field.uiType = field.saveFormField.uiType;
        }

        // update default values
        this.updateDefaultValue(field, data, formData);

        /* update default value */
        if (angular.isArray(data)) {
            data = data[0];
        }

        /* check if field is relevant to the current service form */
        if (!this.isIlsFieldExists(data, formData, field)) {
            field.uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
        }

        //convert date field default value string to date for date picker
        if (field.uiType === FormBuilderEnums.UI_TYPE.DATE || field.uiType === FormBuilderEnums.UI_TYPE.DATE_AND_TIME) {
            let dateUtils: DateUtils = new DateUtils();
            if (!(formData[field.name] instanceof Date)) { //It is not in date format
                formData[field.name] = dateUtils.convertIlsDateStringToDateType(formData[field.name]);
            }

            if (field.populator && field.populator.params && field.populator.params.defaultValue) {
                if (!formData[field.name] && // No option selected yet
                    field.populator.params.defaultValue === FormBuilderEnums.TODAY) { // Today date as default

                    formData[field.name] = new Date();

                }
            }
            if (field.minDate === 'now') {
                field.minDate = new Date();
            }
        }

    }

    private singleValueBehaviourDefined(field) {
        return field.populator && field.populator.params && field.populator.params.singleValueBehaviour;
    }

    private needToRestoreUiType(field) {
        return field.uiType && field.uiType === FormBuilderEnums.UI_TYPE.LABEL && field.saveFormField && field.saveFormField.uiType && field.options && field.options.length > 1;

    }

    private checkIfCondValEqFormCondKey(formData, condition) {
        if (angular.isArray(condition.value)) {
            return condition.value && (condition.value.indexOf(formData[condition.key]) !== -1);
        }
        return condition.value && (formData[condition.key] === condition.value);

    }

    private updateDefaultValue(field, data, formData) {
        /* update default value */
        if (angular.isArray(data)) {
            data = data[0];
        }
        let valuePath = field.valuePath || 'chosen-parameters-map';
        if (data[valuePath] && !formData[field.name]) {
            /* If field.valuePath exists
             * Take the value from the valuePath key
             * i.e. "ub-last-interest-date":"20160621",
             *
             * If field.valuePath does not exists
             * 'chosen-parameters-map' value is a JSON, take it from field.key as key
             * i.e. "chosen-parameters-map":{
             *      "last_interest_date":"20160522",
             *      "allowed_media":"",
             *      "service_level":"",
             *      "delivery_method":"",
             *      "holdingrec_id":"58684",
             *      "language":"",
             *      "send_directly":"Y",
             *      "willing_to_pay":"N"
             *  },
             */
            let curValue = angular.isObject(data[valuePath]) ? data[valuePath][field.key] : data[valuePath];
            if(field.uiType == FormBuilderEnums.UI_TYPE.CHECK_BOX && curValue == null){
                curValue = 'N'
            }
            //fields with input type number should be parsed to int
            if (curValue && field.inputType === 'number') {
                curValue = parseInt(curValue);
            }
            this.updateFormData(formData, field, curValue);
            //formData[field.name] = angular.isObject(data[valuePath]) ?  data[valuePath][field.key] : data[valuePath];
            field.value = curValue;//formData[field.name];
        }

    }

    private isIlsFieldExists(data, formData, field) {
        let existingPath = field.existingPath || 'optional-service-parameters/' + field.name;

        let keyAndData = this.parseDataAndKeyFromPath(data, existingPath, formData);
        data = keyAndData.data;
        let key = keyAndData.key;
        /* field is already handled, it is exists in ILS */
        if (formData[field.name]) {
            return true;
        }

        let existInIls = (data && angular.isDefined(data[key])) || (data && angular.isArray(data) && angular.isDefined(data[0][key]));
        let isMultiValue = !field.disableMultiValueCheck && field.options && field.options.length > 0;
        let isInternal = field.fieldType === FormBuilderEnums.FIELD_TYPE.INTERNAL;

        let isExist = existInIls || isMultiValue || isInternal;

        delete field.disableMultiValueCheck;

        return isExist;
    }

    private filterPopulator(form, field, formData, data) {
        if (!field.populator || !field.populator.params || !field.populator.params.filters) { //do nothing
            return data; //stay as is
        }

        return filter(data, (el) => {
            let matched = true;

            forEach(field.populator.params.filters, (curFilter) => {
                let curField = this.getFieldByName(form, curFilter);
                if (curField) {
                    let key = this.getRequestKey(curField, formData);
                    /* PRM-33542 Hold request fails*/
                    //                   if (key==='item-status-name') {
                    //                      key = 'item-status';
                    //                  }
                    if (angular.isArray(el[key])) { // current data is array
                        /* check if value exists in array data */
                        let curMatched = false;
                        forEach(el[key], (curData) => {
                            if (curData && (!formData[curFilter] || this.convertToString(curData[curField.populator.params.key]) === this.convertToString(formData[curFilter]))) {
                                curMatched = true; //found in array
                            }
                        });
                        matched = matched && curMatched;
                    } else if (angular.isObject(el[key])) {  //current data is Json?
                        let curMatched = false;
                        if (!formData[curFilter] || el[key][curField.populator.params.key] === formData[curFilter]) {
                            curMatched = true;
                        }
                        matched = matched && curMatched;
                    } else if (formData[curFilter] && el[key] !== formData[curFilter]) { //condition not match
                        matched = false;
                    }
                }
            });

            return matched;

        });


    }

    private convertToString(value) {
        if (!value) {
            return value;
        }

        return value.toString();
    }

    private getRequestKey(field, formData) {


        if (!field.path || field.path === FormBuilderEnums.ROOT) {
            return field.name;
        }

        return this.getRequestKeyByPath(field.path, formData);

    }

    private getRequestKeyByPath(path, formData) {

        if (!path)
            return '';
        let pathArray = path.split('/');

        let key = pathArray[pathArray.length - 1];
        let openParamIndex = key.indexOf('{');
        let closeParamIndex = key.indexOf('}');
        let paramStr = key.substring(openParamIndex + 1, closeParamIndex);

        if (openParamIndex >= 0) {
            let paramArray = split(paramStr, ':');
            if (paramArray[0] === FormBuilderEnums.FIELD) {
                key = formData[paramArray[1]];
            }
        }

        return key;
    }

    private isDuplicatedFieldExists(form, field) {
        let duplicatedField = this.getFieldByName(form, field.duplicateOf);
        if (duplicatedField) {
            field.mandatory = duplicatedField.mandatory;
            field.mandatoryIndicator = duplicatedField.mandatoryIndicator;
        }
        return (duplicatedField && duplicatedField.options && duplicatedField.options.length > 0);
    }

    private getFieldByName(form, name) {
        let matchedFields = filter(form, (el) => { return el.name === name; });
        return matchedFields[0];
    }

    private getIlsDataByPath(data, field: IFormField, formData) {
        let path = field.path;
        if (!path) {
            return { key: field.name, data: data };
        }

        return this.parseDataAndKeyFromPath(data, path, formData);

    }

    private parseDataAndKeyFromPath(data, path, formData) {
        let key;
        forEach(path.split('/'), (curPath, idx, array) => {
            if (idx === array.length - 1) {  //last element is the key
                key = curPath;
            } else {
                if (!data) {
                    data = [];
                } else if (angular.isArray(data)) {
                    /* check if need to filter by cur path */
                    let openParamIndex = curPath.indexOf('{');
                    if (openParamIndex > 0) {
                        let closeParamIndex = curPath.indexOf('}');
                        let paramStr = curPath.substring(openParamIndex + 1, closeParamIndex);
                        curPath = curPath.substring(0, openParamIndex);
                        let paramArray = split(paramStr, ':');
                        data = filter(data, (el) => {
                            return el[paramArray[1]] === formData[paramArray[0]];
                        });
                    }
                    if (data) {
                        data = data[0]; //TODO
                    }
                }
                if (data) {
                    data = data[curPath];
                }
            }

        });

        key = this.getRequestKeyByPath(path, formData);

        return { key: key, data: data };

    }

    private parseTimeForMultiSelect(item, field, formData) {

        if (!field.populator || !field.populator.params) {
            return [];
        }

        if (field.populator.params.func) {
            return field.populator.params.func(field, item);
        }

        return { label: item[field.populator.params.key], value: item[field.populator.params.value] };

    }

    /* 
     * There are two problems with Angular Material in md-select
     * 1. When the selected option is generated by the system (default value),
     *    The "ngMessage" failed validate the field on required
     * 2 when a field's options are changed because it depend on another field's value,
     *   On the angular digest, the options is still the previous but the value is changed.
     *   In this situation, the value can be not includes in the options list and the required check fails
     *     
     * To avoid those situations, if the selected option is already defined, the user cannot reset the option (md-select)
     * The mandatory validation is removed
     */
    protected updateFormData(formData, field, value) {
        if (field.populator && field.populator.deleteFromFormDataIfHidden && field.populator.deleteFromFormDataIfHidden === 'true' && field.uiType === FormBuilderEnums.UI_TYPE.HIDDEN) {
            delete formData[field.name];
        } else if (value) {
            formData[field.name] = value;
        } else {
            delete formData[field.name];
        }

        if (field.uiType === FormBuilderEnums.UI_TYPE.DROP_DOWN || field.uiType === FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH) {
            if (value) {
                if (field.mandatory) {
                    field.mandatoryIndicator = true; //"backup" mandatory only if it is true
                }
                field.mandatory = false;
            } else if (field.mandatoryIndicator) { //in case a mandatory was exists but was removed
                field.mandatory = true;
            }
        }
    }


    protected otherInstitutionChosen(field, formFields, formData, data): void {
        let localData = data[0];
        if (formData['preferredPickupInstitution'] === localData['preferredPickupInstitutionDefault']) {
            field.uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
        } else {
            field.uiType = field.origUiType;
        }

    }

    protected getUITypeByBookingResolution(data): string {
        switch (data.bookingResolution) {
            case "DAYS":
            case "DAYS_OVERNIGHT":
                return FormBuilderEnums.UI_TYPE.DATE;
            case "HOURS":
                return FormBuilderEnums.UI_TYPE.DATE_AND_HOURS;
            case "MINUTES":
                return FormBuilderEnums.UI_TYPE.DATE_AND_TIME;
            default:
                return FormBuilderEnums.UI_TYPE.DATE_AND_TIME;
        }
    }

    protected checkAvailabilityLinkPopulator(field, form, formData, data): void{
        if (angular.isArray(data)) {
            data = data[0];
        }
        let checkAvailabilityUrl: string = data['chosen-parameters-map'][field.key];
        let selectedPickupLocation: string = formData['pickupLocation'] || '';
        let pickupLibraryId = selectedPickupLocation.match(/[0-9]*(?=\$\$)/) || '';
        if (checkAvailabilityUrl){
            if (checkAvailabilityUrl.indexOf('pickUpLibraryId=') > -1){
                formData[field.name] = checkAvailabilityUrl.replace(/pickUpLibraryId=.*?(?=&|$)/, 'pickUpLibraryId=' + pickupLibraryId);
            }
            else{
                formData[field.name] = checkAvailabilityUrl + '&pickUpLibraryId=' + pickupLibraryId;
            }
        }

    }

    protected personalDeliveryDependency(field, formFields, formData, data): void {
        field.uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
        let row = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.HOLD_BOOKING_OPTIONAL_REQUEST_PARAMETERS, {source2: field.key, target: 'Yes'});
        if(!row || row.length == 0){
            return;
        }
        if(formData.pickupLocation == null || formData.pickupLocation == "" ){
            return;
        }
        let val:string[] = formData.pickupLocation.split("$$");
        if(val != null && val.length ==2){
            let type :string = val[1];
            if(type && (type.startsWith("USER_HOME_ADDRESS") || type.startsWith("USER_WORK_ADDRESS") || type.startsWith("P_DELIV_ADDRESS"))){
                field.uiType = FormBuilderEnums.UI_TYPE.TEXT;
                field.mandatory = (row[0]['source5'] === 'true');
                for(let groupList of data[0]["groups-list-map"].filter(e1 => { return String(e1.requestType) == "hold"})){
                    let groupListRow = groupList.pickupLocation;
                    if(groupListRow == null || groupListRow == ''){
                        continue;
                    }
                    let pickupLocRow = groupListRow.filter( e1 => {return e1.key === formData.pickupLocation});
                    if(pickupLocRow == null || pickupLocRow == ''){
                        continue;
                    }
                    this.updateFormData(formData, field, getValue(pickupLocRow[0],field.key));
                    break;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/abstractRequest.ts